import { render, staticRenderFns } from "./gchSave.vue?vue&type=template&id=8ca9fe26&scoped=true&"
import script from "./gchSave.vue?vue&type=script&lang=js&"
export * from "./gchSave.vue?vue&type=script&lang=js&"
import style0 from "./gchSave.vue?vue&type=style&index=0&id=8ca9fe26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca9fe26",
  null
  
)

export default component.exports